import styled from 'styled-components';

export const SelfServeDashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  gap: 24px;
  padding: 0 12px;
  margin-bottom: 24;
`;
